import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { AccountLoader, AccountSelectorViewModel, CachedAccountLoader, IAccountLoader } from "../rawData/accountSelector/accountSelector-viewModel";
import { DetailValueSelectorViewModel, ValueLoader } from "../rawData/detailValueSelector";
import  { TransactionCreationView } from "./transactionCreation-view"

export class TransactionCreationViewModel extends WindowViewModel implements IPopup{
    public getTitle(): string {
        return 'ثبت سند حسابداری';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.accountLoader = new CachedAccountLoader();
        this.detailLoader = new ValueLoader();
        this.entries = ObservableArray.create<entry>();
        this.closePopup = null;
    }

    public closePopup : (resultCode:string)=>void;
    GetDefaultView(): View <ViewModel> {
        return new TransactionCreationView();
    }
    public getTypeId(): string {
        return "VM-0A7D0438-5940-42A4-AF84-F4CC2051420D"
    }
    private accountLoader : IAccountLoader;
    private detailLoader : ValueLoader;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set transactionTitle(v: string) { this._transactionTitle = v; } public get transactionTitle(): string { return this._transactionTitle;} private _transactionTitle: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set refCode(v: string) { this._refCode = v; } public get refCode(): string { return this._refCode;} private _refCode: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set entries(v: ObservableArray<entry>) { this._entries = v; } public get entries(): ObservableArray<entry> { return this._entries;} private _entries: ObservableArray<entry>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async loadById(id:string){
        try {
            this.isLoading = true;
            let result = (await ServerConnection.callServer("Complex/AccountingServices/LoadTransaction",{
                Id:id
            })).Transaction;
            this.transactionTitle = result.Name;
            this.id = result.Id;
            this.refCode = result.CrossReferenceCode;
            this.comment = result.Description;
            this.time = moment.utc(result.Time);
            this.code = result.TransactionCode;
            this.entries.update(...result.Entries.map(q=>{
                let r = new entry(this,this.accountLoader,this.detailLoader);
                r.accountSelector = new AccountSelectorViewModel(r,this.accountLoader);
                r.accountSelector.selectById(q.Account[q.Account.length-1].AccountId);
                r.comment = q.Description;
                if(q.Amount<0){
                    r.creditAmount = -q.Amount;
                    r.debtAmount = null;
                }else{
                    r.debtAmount = q.Amount;
                    r.creditAmount = null;
                }
                r.index = q.Order;
                r.details.update(...q.DetailValues.map(w=>{
                    let d = new detail(r);
                    d.assignmentId = w.AccountDetailId;
                    d.name = w.AccountDetailName;
                    d.valueSelector = new DetailValueSelectorViewModel(d,w.DetailId,this.detailLoader);
                    d.valueSelector.selectById(w.DetailValueId);
                    return d;
                }))
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    removeEntry(entry:entry){
        this.entries.remove(entry);
        this.updateEntryIndices();
    }

    addNewEntry(){
        let e = new entry(this,this.accountLoader,this.detailLoader);
        this.entries.push(e);
        this.updateEntryIndices();
    }

    updateEntryIndices(){
        this.entries.forEach((x,i)=>{
            x.index = i+1;
        });
    }
    async requestCloseTransactionCreation(shallConfirm:boolean=true,message:string='no') {

        let result:string = 'yes';
        if(shallConfirm==true){
            result =await this.messageBoxWarningYesNo('آیا از بستن صفحه اطمینان دارید؟','خروج');
        }
        if(result=='yes'){
            if(this.closePopup!=null){
                this.closePopup(message);
            }else{
                this.close();
            }
        }
    }
    async save(){
        try {
            this.isLoading = true;
            try {
                this.isLoading = true;
                let result:{id:string,code:string};
                if(stringIsNullOrEmpty(this.id)){
                    result = await this.trySave();
                }else{
                    result = await this.tryUpdate();
                }
                this.code = result.code;
                this.id = result.id;
                await this.messageBoxConfirmSuccess(`تراکنش با شماره ${this.code} ذخیره شد.`,'ثبت تراکنش');
                this.requestCloseTransactionCreation(false,'yes');
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در ثبت تراکنش','خطا');
            } finally {
                this.isLoading = false;
            }    
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async trySave():Promise<{id:string,code:string}>{
        let result = await ServerConnection.callServer('Complex/AccountingServices/CreateTransaction',{
            Name:this.transactionTitle,
            Time:this.time,
            Description:this.comment,
            Entries:this.entries.map(q=>{
                return {
                    AccountId:q.accountSelector.selectedAccount.id,
                    Description:q.comment,
                    Amount:q.getAmount(),
                    Order:q.index,
                    DistinguishingValues:q.details.map(w=>{
                        return {
                            AccountDetailId:w.assignmentId,
                            ValueId:w.valueSelector.selectedItem.id
                        }
                    }) 
                }
            })
        });
        if(result.IsSuccessful==false){
            throw "Failed";
        }else{
            return {
                id : result.TransactionId,
                code : result.TransactionCode
            };
        }
    }
    async tryUpdate():Promise<{id:string,code:string}>{
        let result = await ServerConnection.callServer('Complex/AccountingServices/UpdateTransaction',{
            Id:this.id,
            Name:this.transactionTitle,
            Time:this.time,
            Description:this.comment,
            Entries:this.entries.map(q=>{
                return {
                    AccountId:q.accountSelector.selectedAccount.id,
                    Description:q.comment,
                    Amount:q.getAmount(),
                    Order:q.index,
                    DistinguishingValues:q.details.map(w=>{
                        return {
                            AccountDetailId:w.assignmentId,
                            ValueId:w.valueSelector.selectedItem.id
                        }
                    }) 
                }
            })
        });
        if(result.IsSuccessful==false){
            throw "Failed";
        }else{
            return {
                id : result.TransactionId,
                code : result.TransactionCode
            };
        }
    }
}

export class entry extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:TransactionCreationViewModel,loader:IAccountLoader,valueLoader:ValueLoader) {
        super(parent);
        this._typedParent =parent;
        this.details = ObservableArray.create<detail>();
        this.valueLoader = valueLoader;
        this.accountSelector = new AccountSelectorViewModel(this,loader);
        this.accountSelector.onSelectionChanged = a=>{
            if(a==null){
                this.details.clear();
            }else{
                this.details.update(...a.details.map(q=>{
                    let d  = new detail(this);
                    d.assignmentId = q.assignmentId;
                    d.name = q.name;
                    d.valueSelector = new DetailValueSelectorViewModel(d,q.id,this.valueLoader);
                    return d;
                }));
            }
        }
    }
    private valueLoader : ValueLoader;
    private _typedParent : TransactionCreationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set accountSelector(v: AccountSelectorViewModel) { this._accountSelector = v; } public get accountSelector(): AccountSelectorViewModel { return this._accountSelector;} private _accountSelector: AccountSelectorViewModel;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set debtAmount(v: number) { this._debtAmount = getAsNumber(v,true); } public get debtAmount(): number { return this._debtAmount;} private _debtAmount: number;
    public set creditAmount(v: number) { this._creditAmount =getAsNumber(v,true); } public get creditAmount(): number { return this._creditAmount;} private _creditAmount: number;
    public set details(v: ObservableArray<detail>) { this._details = v; } public get details(): ObservableArray<detail> { return this._details;} private _details: ObservableArray<detail>;
    getAmount():number{
        if(this.debtAmount>0){
            return this.debtAmount;
        }
        return -this.creditAmount;
    }
    remove(){
        this._typedParent.removeEntry(this);
    }
}

export class detail extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set assignmentId(v: string) { this._assignmentId = v; } public get assignmentId(): string { return this._assignmentId;} private _assignmentId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set valueSelector(v: DetailValueSelectorViewModel) { this._valueSelector = v; } public get valueSelector(): DetailValueSelectorViewModel { return this._valueSelector;} private _valueSelector: DetailValueSelectorViewModel;
    
}